import type { InferOutput } from 'valibot'
import { array, intersect, object } from 'valibot'
import { baseBodySchema } from '~/utils/solr/body'
import { headersSchema } from '~/utils/solr/headers'
import { lawSchema } from '~/utils/solr/law'

export const solrLawResponseSchema = object({
  responseHeader: headersSchema,
  response: intersect([
    baseBodySchema,
    object({
      docs: array(lawSchema),
    }),
  ]),
})

export type SolrLawResponseSchema = InferOutput<typeof solrLawResponseSchema>

export function useLawQuery(idRef?: MaybeRefOrGetter<string | undefined | null>) {
  const options = useSolrQueryOptions({
    endpoint: 'laws',
    params: idRef ? computed(() => ({ lawId: toValue(idRef) })) : undefined,
    schema: solrLawResponseSchema,
    enabled(params) {
      return !idRef || !!params?.lawId
    },
  })

  return useQuery(options)
}
